/**
 * Label schema
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import {
	BP,
	ISchemaConstObject,
	ISchemaValue,
	ISchemaValueObjectOpts,
	TSchemaConstObjectProps,
	TSchemaConstObjectPropsSpec
} from "@adapptio/lib-blueprint";
import { termsEditor } from "../terms";
import { IconSchema } from "./Icon";
import { LinkSchema } from "./Link";
import { TextSchema } from "./Text";

/**
 * Label props
 */
export const LabelProps = {
	text: BP.Prop(TextSchema(), 0),

	icon: BP.Prop(IconSchema(), 10),

	link: BP.Prop(LinkSchema(), 50),
};

/**
 * Label props type
 */
export type TLabelProps = Partial<TSchemaConstObjectPropsSpec<typeof LabelProps>>;

/**
 * Label schema
 *
 * @param opts Options
 */
export function LabelSchema(
	opts: Partial<ISchemaValueObjectOpts<TSchemaConstObjectProps>> = { alias: "label" }
): ISchemaValue<ISchemaConstObject<TSchemaConstObjectProps>> {
	return BP.Object({
		...termsEditor.schemas.label.schema,
		...opts,
		props: {
			...LabelProps,
			...opts.props
		}
	});
}
